import ExamItem from './ExamItem';

export default ExamItem;
